import { Result } from "./index";
import { ResponseData } from "./tunnel-message-data";

/**
 * @hidden
 */
export interface GetResultsResponse extends ResponseData {
    type: '@stemcstudio/gradebook:get-results-response';
    value?: Result[];
}

/**
 * @hidden
 */
export function isGetResultsResponse(message: MessageEvent): message is MessageEvent<GetResultsResponse> {
    const duck = message as MessageEvent<GetResultsResponse>;
    if (duck.data.type && duck.data.type === '@stemcstudio/gradebook:get-results-response') {
        return true;
    } else {
        return false;
    }
}
